import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { useMemo } from 'react';
import { composeRenderProps } from 'react-aria-components';
import _ListBoxItem from './aria/list-box/list-box-item.esm.js';
import { useComponentTheme } from '../../theme/theme.context.esm.js';

var _excluded = ["className"];
function ListBoxItem(_ref) {
  var _props$value;
  var _className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useComponentTheme('ListBoxItem');
  var textValue = ((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.label) || props.textValue || (typeof props.children === 'string' ? props.children : undefined);
  var classes = useMemo(function () {
    return composeRenderProps(_className, function (className, renderProps) {
      var classes = theme(_objectSpread2(_objectSpread2({}, renderProps), {}, {
        className: className
      }));
      return "csg-tw-list-box-item ".concat(classes);
    });
  }, [_className, theme]);
  return /*#__PURE__*/React.createElement(_ListBoxItem, _extends({}, props, {
    textValue: textValue,
    className: classes
  }));
}

export { ListBoxItem as default };
//# sourceMappingURL=list-box-item.esm.js.map
